export default {
  install(Vue, options) {
    Vue.prototype.global = {
      erp_flag: true,
    };
  }
}




// WEBPACK FOOTER //
// ./src/utils/const.js